import { useEffect, useState } from "react";
import { process } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Label,
  Form,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import PropTypes from "prop-types";


import { useMsal } from "@azure/msal-react";
import useAuth from "../components/authGuard/useAuth";

import { Grid, GridColumn } from "@progress/kendo-react-grid";

import { ColumnProps } from "../components/kendoComponents/columnProps/ColumnProps";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";

import FeatherIcon from "feather-icons-react";
import "../assets/scss/kendo-theme-custom.scss";

import { HtmlCell } from "../components/kendoComponents/htmlCell/HtmlCell";


import {
  fetchDataCatalogById,
  fetchAssetDataCatalog,
  fetchDistinctProductMetadata,
  fetchAttributeDataCatalog,
  fetchDelegatesDataCatalog,
  fetchPossibleDelegates,
  fetchDataProducts,
  addDelegate,
  deleteDelegate,
  updateType,
  updateAttribute,
  setFilterDataProducts,
  setFilterIntervallo,
  toogleDataCheck,
} from "../store/app/DataQualityStatus/DataQualitySlice";



const IsPersonalCell = (props) => {
  const [value, setValue] = useState(props.dataItem.is_personal);

  useEffect(() => {
    setValue(props.dataItem.is_personal);
  }, [props.dataItem.is_personal]);

  const handleChange = (e) => {
    const newValue = e.target.checked;
    setValue(newValue);
    props.onSave(newValue, "is_personal", props.dataItem);
  };

  return (
    <td>
      <Input
        type="checkbox"
        checked={value}
        disabled={!(props.isOwner || props.isDelegate)}
        onChange={handleChange}
      />
    </td>
  );
};

IsPersonalCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  isOwner: PropTypes.bool.isRequired,
  isDelegate: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
};

const IsPkCell = (props) => {
  const [value, setValue] = useState(!!props.dataItem.is_pk);

  useEffect(() => {
    setValue(!!props.dataItem.is_pk);
  }, [props.dataItem.is_pk]);

  const canEdit = props.isOwner || props.isDelegate;

  const handleChange = (e) => {
    const newValue = e.target.checked;
    setValue(newValue);
    props.onSave(newValue, "is_pk", props.dataItem);
  };

  return (
    <td>
      <Input
        type="checkbox"
        checked={value}
        disabled={!canEdit}
        onChange={handleChange}
      />
    </td>
  );
};

IsPkCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  isOwner: PropTypes.bool.isRequired,
  isDelegate: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
};

const AddDelegateCell = (props) => (
  <td className="text-center">
    <Button
      color="success"
      size="sm"
      disabled={!props.canManageDelegates}
      onClick={() => props.onAdd(props.dataItem)}
    >
      <FeatherIcon icon="plus" size={14} />
    </Button>
  </td>
);

AddDelegateCell.propTypes = {
  onAdd: PropTypes.func.isRequired,
  dataItem: PropTypes.object.isRequired,
  canManageDelegates: PropTypes.bool.isRequired,
}

const DeleteDelegateCell = (props) => (
  <td className="text-center">
    {props.dataItem.user_role?.toLowerCase() === "owner" || !props.canManageDelegates ? (
      <span className="text-muted">-</span>
    ) : (
      <Button
        color="danger"
        size="sm"
        onClick={() => props.onDelete(props.dataItem)}
      >
        <FeatherIcon icon="minus" size={14} />
      </Button>
    )}
  </td>
);

DeleteDelegateCell.propTypes = {
  onDelete: PropTypes.func.isRequired,
  dataItem: PropTypes.object.isRequired,
  canManageDelegates: PropTypes.bool.isRequired,
};


const DataCatalogDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { typeId } = useParams();

  let [searchParams] = useSearchParams();


  const { accounts } = useMsal();
  const { isAdmin } = useAuth();

  const account = accounts?.[0];

  const fullTextSearch = useSelector(
    (state) => state.dataQualityReducer.fullTextSearch || ""
  );

  const isCompleteSearch = useSelector(
    (state) => state.dataQualityReducer.isCompleteSearch || false
  );


  const dataCatalogSingle = useSelector(
    (state) => state.dataQualityReducer.dataCatalogSingle || {}
  );

  const dataCatalogAssets = useSelector(
    (state) => state.dataQualityReducer.assetDataCatalog || []
  );

  const dataCatalogDelegates = useSelector(
    (state) => state.dataQualityReducer.delegates || []
  );

  const dataCatalogAvailableDelegates = useSelector(
    (state) => state.dataQualityReducer.nonLinkedDelegates || []
  );

  const dataCatalogAttributes = useSelector(
    (state) => state.dataQualityReducer.attributesDataCatalog || []
  );

  const dataCatalogOwnership = useSelector(
    (state) => state.dataQualityReducer.dataCatalogOwnership || []
  );

  const distinctProductMetadata = useSelector(
    (state) => state.dataQualityReducer.distinctProductMetadata || []
  );

  const dataProducts = useSelector( (state) => state.dataQualityReducer.dataProducts || [] );


  const isSpinnerVisible = useSelector(
    (state) => state.dataQualityReducer.loading
  );

  const [showAttributeId, setShowAttributeId] = useState(false);


  const [dataStateAssets, setDataStateAssets] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 10,
  });
  const [dataResultAssets, setDataResultAssets] = useState(process(dataCatalogAssets, dataStateAssets));

  const [dataStateDistinctProductMetadata, setDataStateDistinctProductMetadata] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 10,
  });
  const [dataResultDistinctProductMetadata, setDataResultDistinctProductMetadata] = useState(process(distinctProductMetadata, dataStateDistinctProductMetadata));


  const [assetsModalOpen, setAssetsModalOpen] = useState(false);
  const [assetsModalTab, setAssetsModalTab] = useState("asset");

  const [dataStateDelegates, setDataStateDelegates] = useState({
    sort: [
      {
        field: "delegate_name",
        dir: "asc",
      },
    ],
    skip: 0,

  });

  const [dataResultDelegates, setDataResultDelegates] = useState(process(dataCatalogDelegates, dataStateDelegates));

  const [delegatesModalOpen, setDelegatesModalOpen] = useState(false);


  const [addDelegatesModalOpen, setAddDelegatesModalOpen] = useState(false);

  const [dataStateAvailableDelegates, setDataStateAvailableDelegates] = useState({
    sort: [{ field: "user_name", dir: "asc" }],


  });
  const [dataResultAvailableDelegates, setDataResultAvailableDelegates] = useState(process(dataCatalogAvailableDelegates, dataStateAvailableDelegates));


  const [dataStateAttributes, setDataStateAttributes] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });

  const [dataResultAttributes, setDataResultAttributes] = useState(process(dataCatalogAttributes, dataStateAttributes));


  const [description, setDescription] = useState(dataCatalogSingle?.type_description || "");
  const [name, setName] = useState(dataCatalogSingle?.type_name || "");


  const [delegateSearchTerm, setDelegateSearchTerm] = useState("");



  const [editName, setEditName] = useState(false);
  const [editDescription, setEditDescription] = useState(false);


  const [isOwner, setIsOwner] = useState(false);
  const [isDelegate, setIsDelegate] = useState(false);
  const canManageDelegates = isAdmin || isOwner || isDelegate;





  useEffect(() => {
    dispatch(fetchDataCatalogById(typeId));
    dispatch(fetchAssetDataCatalog(typeId));
    dispatch(fetchDistinctProductMetadata(typeId));
    dispatch(fetchAttributeDataCatalog(typeId, fullTextSearch, isCompleteSearch));
    dispatch(fetchDelegatesDataCatalog(typeId));
    dispatch(fetchDataProducts());
  }, [typeId]);

  useEffect(() => {
    if (dataCatalogOwnership.length > 0 && typeId && account.username) {
      const ownershipInfo = checkUserOwnership(dataCatalogOwnership, typeId, account.username);

      setIsOwner(ownershipInfo.isOwner);
      setIsDelegate(ownershipInfo.isDelegate);


    } else {
      // Reset when no ownership data
      setIsOwner(false);
      setIsDelegate(false);

    }
  }, [dataCatalogOwnership, typeId, account.username]);

  useEffect(() => {
    if (dataCatalogSingle?.type_description) {
      setDescription(dataCatalogSingle.type_description);
    }
    if (dataCatalogSingle?.type_name) {
      setName(dataCatalogSingle.type_name);
    }
  }, [dataCatalogSingle]);


  useEffect(() => {
    setDataResultDistinctProductMetadata(process(distinctProductMetadata, dataStateDistinctProductMetadata));
  }, [distinctProductMetadata]);

  useEffect(() => {
    setDataStateAssets((prev) => ({
      ...prev,
      sort: [
        {
          field: "code",
          dir: "asc",
        },
      ],
      skip: 0,
      take: 10,
    }));
    setDataResultAssets(process(dataCatalogAssets, dataStateAssets));
  }, [dataCatalogAssets]);

  useEffect(() => {
    setDataStateDelegates((prev) => ({
      ...prev,
      sort: [
        {
          field: "delegate_name",
          dir: "asc",
        },
      ],
    }));
    setDataResultDelegates(process(dataCatalogDelegates, dataStateDelegates));
  }, [dataCatalogDelegates]);

  useEffect(() => {
    setDataResultAvailableDelegates(process(dataCatalogAvailableDelegates, dataStateAvailableDelegates));
  }, [dataCatalogAvailableDelegates]);

  useEffect(() => {
    let filteredDelegates = dataCatalogAvailableDelegates;

    if (delegateSearchTerm.trim() !== "") {
      filteredDelegates = dataCatalogAvailableDelegates.filter(delegate =>
        delegate.name?.toLowerCase().includes(delegateSearchTerm.toLowerCase()) ||
        delegate.first_name?.toLowerCase().includes(delegateSearchTerm.toLowerCase()) ||
        delegate.last_name?.toLowerCase().includes(delegateSearchTerm.toLowerCase())
      );
    }

    setDataResultAvailableDelegates(process(filteredDelegates, dataStateAvailableDelegates));
  }, [dataCatalogAvailableDelegates, delegateSearchTerm, dataStateAvailableDelegates]);

  const hasHtmlLikeContent = (s) => {
    if (!s || typeof s !== "string") return false;
    // Hard cap to avoid very large inputs (defensive)
    if (s.length > 5000) s = s.slice(0, 5000);
    const lt = s.indexOf("<");
    if (lt === -1) return false;
    const gt = s.indexOf(">", lt + 1);
    if (gt === -1) return false;
    // Quick tag start check
    return /<\/?[a-zA-Z]/.test(s.slice(lt, gt + 1));
  };

  useEffect(() => {
    // Check if we should sort HTML content first (from tooltip navigation)
    const shouldSortHtml = searchParams.get('sortHtml') === 'true';

    let processedAttributes = [...dataCatalogAttributes];

    if (shouldSortHtml) {
      processedAttributes = processedAttributes.sort((a, b) => {
        const entityRegex = /&[a-zA-Z0-9#]+;/; // simple, no nested quantifiers

        const checkForHTML = (item) => {
          const name = item.attribute_name || "";
          const description = item.attribute_description || "";
          return (
            hasHtmlLikeContent(name) ||
            hasHtmlLikeContent(description) ||
            entityRegex.test(name) ||
            entityRegex.test(description)
          );
        };

        const aHasHTML = checkForHTML(a);
        const bHasHTML = checkForHTML(b);

        if (aHasHTML && !bHasHTML) return -1;
        if (!aHasHTML && bHasHTML) return 1;

        const aName = (a.attribute_name || "").toLowerCase();
        const bName = (b.attribute_name || "").toLowerCase();
        return aName.localeCompare(bName);
      });
    }

    setDataStateAttributes((prev) => ({
      ...prev,
      sort: [
        {
          field: "code",
          dir: "asc",
        },
      ],
    }));

    setDataResultAttributes(process(processedAttributes, dataStateAttributes));
  }, [dataCatalogAttributes]);



  const handleSave = (field) => {
    if (field === 'name') {
      setEditName(false);
    } else if (field === 'description') {
      setEditDescription(false);
    }

    // Check if either name or description has changed
    const nameChanged = name !== dataCatalogSingle.type_name;
    const descriptionChanged = description !== dataCatalogSingle.type_description;

    if (nameChanged || descriptionChanged) {
      dispatch(updateType(
        typeId,
        account.username,
        name,
        description
      ));
    }
  };


  const handleAttributeSave = (newValue, field, dataItem) => {
    // Determine the values based on which field is being updated
    let attributeName = dataItem.attribute_name;
    let attributeDescription = dataItem.attribute_description;
    let isPersonal = dataItem.is_personal;

    // Update the specific field that changed
    if (field === 'attribute_name') {
      attributeName = newValue;
    } else if (field === 'attribute_description') {
      attributeDescription = newValue;
    } else if (field === 'is_personal') {
      isPersonal = newValue;
    }

    // Call updateAttribute with all parameters matching the slice signature
    dispatch(updateAttribute(
      typeId,
      account.username,
      attributeName,
      attributeDescription,
      dataItem.attribute_id,
      isPersonal,
      { fullTextSearch, isExtendedSearch: isCompleteSearch }
    ));
  };

  const handleOpenAddDelegates = () => {
    if (!canManageDelegates) return;
    setDelegateSearchTerm(""); // Reset search when opening modal
    dispatch(fetchPossibleDelegates(typeId));
    setAddDelegatesModalOpen(true);
  };

  const handleDeleteDelegate = (delegateData) => {
    if (!canManageDelegates) return;
    if (!globalThis.confirm(`Delete delegate "${delegateData.user_name}"?`)) return;

    dispatch(deleteDelegate(typeId, delegateData.user_name));

  };

  const handleAddDelegate = (delegateData) => {
    if (!canManageDelegates) return;
    if (!globalThis.confirm(`Add "${delegateData.name}" as delegate?`)) return;
    dispatch(addDelegate(typeId, delegateData.name));
  };

  const checkUserOwnership = (ownershipData, currentTypeId, userEmail) => {
    // Find ownership record for current type and user
    const ownership = ownershipData.find(item =>
      item.type_id === currentTypeId);


    if (!ownership) {
      return {
        isOwner: false,
        isDelegate: false,
        role: null
      };
    }

    const role = ownership.user_role?.toLowerCase();

    return {
      isOwner: role === 'owner',
      isDelegate: role === 'delegate',
      role: ownership.user_role
    };
  };


  const renderIsPersonalCell = (props) => (
    <IsPersonalCell
      {...props}
      isOwner={isOwner}
      isDelegate={isDelegate}
      onSave={handleAttributeSave}
    />
  );

  const renderIsPkCell = (props) => {
    return (
      <IsPkCell
        {...props}
        isOwner={isOwner}
        isDelegate={isDelegate}
        onSave={handleAttributeSave}
      />
    );
  };
  const renderDeleteDelegateCell = (props) => (
    <DeleteDelegateCell
      {...props}
      onDelete={handleDeleteDelegate}
      canManageDelegates={canManageDelegates}
    />
  );

  const renderAddDelegateCell = (props) => (
    <AddDelegateCell
      {...props}
      onAdd={handleAddDelegate}
      canManageDelegates={canManageDelegates}
    />
  );

  const renderHtmlCell = ({ dataItem }, field, editable, onSave) => (
    <HtmlCell
      value={dataItem[field]}
      field={field}
      editable={editable}
      onSave={onSave}
      dataItem={dataItem}
    />
  );


   const quickSearchNavigate = () => {

    const productId = dataProducts
      .filter((product) => product.type_id == dataCatalogSingle.type_id)
      .map((product) => product.productId);

    searchParams.set("dataproducts", JSON.stringify(productId.length > 0 ? productId : []));
    searchParams.set("interval", "-3")
    dispatch(setFilterIntervallo(-3));
    dispatch(setFilterDataProducts(productId.length > 0 ? productId : []));
    dispatch(toogleDataCheck(false));
    navigate(`/versioni?${searchParams.toString()}`);
  }


  return (
    <>
     <Form>
        {/* Row 1: Name, Description, Owner */}
      <Row className="bg-light-primary px-4 py-2">
          <Col>
            <Row className="align-items-center g-3">
              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="type_name" className="mb-1 small">Name</Label>
                {editName ? (
                  <Input
                    className="w-100"
                    id="type_name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onBlur={() => handleSave('name')}
                    onKeyDown={(e) => e.key === 'Enter' && handleSave('name')}
                    autoFocus
                  />
                ) : (
                 <button
                    type="button"
                    className="form-control-plaintext mb-0 px-2 py-1 border border-primary rounded bg-medium-primary text-truncate w-100 d-inline-block text-start fw-bold"
                    onClick={() => (isOwner || isDelegate) && setEditName(true)}
                    disabled={!(isOwner || isDelegate)}
                    style={{ 
                      cursor: (isOwner || isDelegate) ? 'pointer' : 'default',
                      font: 'inherit',
                      color: 'inherit'
                    }}
                    title={dataCatalogSingle.type_name}
                  >
                    {dataCatalogSingle.type_name}
                  </button>
                )}
              </Col>

              <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="type_description" className="mb-1 small">Description</Label>
                {editDescription ? (
                  <Input
                    type="textarea"
                    className="w-100"
                    id="type_description"
                    style={{ minWidth: "400px" }}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    onBlur={() => handleSave('description')}
                    onKeyDown={(e) => e.key === 'Enter' && handleSave('description')}
                    rows="2"
                    autoFocus
                  />
                ) : (
                  <button
                    type="button"
                    className="form-control-plaintext mb-0 px-2 py-1 border border-primary rounded bg-medium-primary text-truncate w-100 d-inline-block text-start fw-bold"
                    onClick={() => (isOwner || isDelegate) && setEditDescription(true)}
                    disabled={!(isOwner || isDelegate)}
                    style={{ 
                      cursor: (isOwner || isDelegate) ? 'pointer' : 'default',
                      font: 'inherit',
                      color: 'inherit'
                    }}
                    title={dataCatalogSingle.type_description}
                  >
                    {dataCatalogSingle.type_description}
                  </button>
                )}
              </Col>

           <Col xs="12" md="auto" lg="auto" className="d-flex flex-column min-w-0">
                <Label for="type_owner" className="mb-1 small">Owner</Label>
                <span
                  className="form-control-plaintext mb-0 px-2 py-1 text-truncate w-100 d-inline-block"
                  title={dataCatalogSingle.type_owner}
                >
                  {dataCatalogSingle.type_owner}
                </span>
              </Col>

            </Row>
          </Col>
        </Row>

        {/* Row 2: Metadata Fields */}
        <Row className="bg-very-light-primary px-4 py-3">
          <Col>
            <Row className="g-3">
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Retention Policy</Label>
                  <p className="pt-0 form-control-plaintext mb-0 text-truncate w-100" title={dataCatalogSingle.type_retention_policy}>
                    {dataCatalogSingle.type_retention_policy || "—"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Is Critical</Label>
                  <p className="pt-0 form-control-plaintext mb-0">
                    {dataCatalogSingle.type_is_critical ? "Yes" : "No"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Manual Adjustment</Label>
                  <p className="pt-0 form-control-plaintext mb-0">
                    {dataCatalogSingle.type_is_manual_adjustment ? "Yes" : "No"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Company ID</Label>
                  <p className="pt-0 form-control-plaintext mb-0 text-truncate w-100" title={dataCatalogSingle.type_company_id}>
                    {dataCatalogSingle.type_company_id || "—"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Steward</Label>
                  <p className="pt-0 form-control-plaintext mb-0 text-truncate w-100" title={dataCatalogSingle.type_steward}>
                    {dataCatalogSingle.type_steward || "—"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Domain Name</Label>
                  <p className="pt-0 form-control-plaintext mb-0 text-truncate w-100" title={dataCatalogSingle.domain_name}>
                    {dataCatalogSingle.domain_name || "—"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1">Domain Description</Label>
                  <p className="pt-0 form-control-plaintext mb-0 text-truncate w-100" title={dataCatalogSingle.domain_description}>
                    {dataCatalogSingle.domain_description || "—"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Domain Owner</Label>
                  <p className="pt-0 form-control-plaintext mb-0 text-truncate w-100" title={dataCatalogSingle.domain_owner}>
                    {dataCatalogSingle.domain_owner || "—"}
                  </p>
                </div>
              </Col>
              <Col xs="12" sm="6" md="3" lg="auto" className="min-w-0">
                <div className="min-w-0">
                  <Label className="mb-1 small">Class</Label>
                  <p className="pt-0 form-control-plaintext mb-0 text-truncate w-100" title={dataCatalogSingle.type_class_name}>
                    {dataCatalogSingle.type_class_name || "—"}
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Row 3: Action Buttons */}
        <Row className="bg-light-primary px-4 py-3">
          <Col>
            <Row className="align-items-center g-2">
              <Col xs="12" lg="auto">
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    color="primary"
                    outline={!showAttributeId}
                    size="md"
                    onClick={() => setShowAttributeId(!showAttributeId)}
                  >
                    <FeatherIcon icon="hash" size={14} className="me-1" />
                    Show Attribute IDs
                  </Button>
                  <Button
                    color="primary"
                    outline
                    size="md"
                    onClick={() => setAssetsModalOpen(true)}
                  >
                    <FeatherIcon icon="database" size={14} className="me-1" />
                    Show Assets
                  </Button>
                  <Button
                    color="primary"
                    outline
                    size="md"
                    onClick={() => setDelegatesModalOpen(true)}
                  >
                    <FeatherIcon icon="users" size={14} className="me-1" />
                    Show Delegates
                  </Button>
                </div>
              </Col>
              <Col xs="12" lg="auto" className="ms-lg-auto">
                <div className="d-flex flex-wrap gap-2 justify-content-lg-end">
                  <Button
                    color="primary"
                    outline
                    size="md"
                    onClick={() => navigate(`/versioni/data-lineage/${typeId}`)}
                  >
                    <FeatherIcon icon="share-2" size={14} className="me-1" />
                    Product Lineage
                  </Button>
                  <Button
                    color="primary"
                    outline
                    size="md"
                    onClick={quickSearchNavigate}
                  >
                    <FeatherIcon icon="search" size={14} className="me-1" />
                    Quick Search
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <Row className="px-4 my-3"></Row>


      <Container fluid className="py-2 px-4  position-relative ">
        <Row>
          <Col>

            <div className="grid_task_container_short border">

              <Grid
                style={{ height: "100%" }}
                sortable={true}
                total={dataResultAttributes?.length}
                data={dataResultAttributes}
                {...dataStateAttributes}
                onDataStateChange={(e) => {
                  setDataStateAttributes(e.dataState);
                  setDataResultAttributes(process(dataCatalogAttributes, e.dataState));
                }}
              >
                <GridColumn
                  cell={(props) => renderHtmlCell(props, "attribute_name", isOwner || isDelegate, handleAttributeSave)}
                  {...ColumnProps("attribute_name", dataStateAttributes)}
                  title="Attribute Name"
                />
                <GridColumn
                  cell={(props) => renderHtmlCell(props, "attribute_description", isOwner || isDelegate, handleAttributeSave)}
                  {...ColumnProps("attribute_description", dataStateAttributes)} title="Description" />

                <GridColumn
                  {...ColumnProps("is_pk", dataStateAttributes)}
                  title="Is Unique Key"
                  cell={renderIsPkCell}
                  
                />
                <GridColumn
                  cell={renderIsPersonalCell}
                  {...ColumnProps("is_personal", dataStateAttributes)}
                  title="Is Personal"
                  

                />
                <GridColumn
                  {...ColumnProps("attribute_type", dataStateAttributes)}
                  title="Type"
                />
                {showAttributeId && <GridColumn
                  {...ColumnProps("attribute_id", dataStateAttributes)}
                  title="Attribute ID"

                />}
              </Grid>
            </div>

          </Col>
        </Row>
        <LoaderSpin isVisible={isSpinnerVisible} />
      </Container>
      {/* Modal for Assets Grid */}
      <Modal
        isOpen={assetsModalOpen}
        toggle={() => setAssetsModalOpen(!assetsModalOpen)}
        size="xl"
        style={{ maxWidth: "65vw" }}
      >
        <ModalHeader toggle={() => setAssetsModalOpen(false)}>
          <FeatherIcon icon="database" size={18} className="me-2" />
          {dataCatalogSingle.type_name}
        </ModalHeader>
        <ModalBody className="p-0">
          <Nav tabs className="px-3 pt-3 border-bottom-0">
            <NavItem>
              <NavLink
                className={`px-4 py-2${assetsModalTab === "asset" ? " active fw-semibold" : " text-muted"}`}
                style={{ cursor: "pointer", borderBottom: assetsModalTab === "asset" ? "2px solid var(--bs-primary)" : "2px solid transparent" }}
                onClick={() => setAssetsModalTab("asset")}
              >
                Asset
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`px-4 py-2${assetsModalTab === "metadata" ? " active fw-semibold" : " text-muted"}`}
                style={{ cursor: "pointer", borderBottom: assetsModalTab === "metadata" ? "2px solid var(--bs-primary)" : "2px solid transparent" }}
                onClick={() => setAssetsModalTab("metadata")}
              >
                Metadata
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={assetsModalTab} className="p-3">
            <TabPane tabId="asset">
              <Grid
                style={{ height: "500px" }}
                pageable={true}
                sortable={true}
                scrollable="scrollable"
                total={dataResultAssets?.length}
                data={dataResultAssets}
                {...dataStateAssets}
                onDataStateChange={(e) => {
                  setDataStateAssets(e.dataState);
                  setDataResultAssets(process(dataCatalogAssets, e.dataState));
                }}
              >
                <GridColumn
                  {...ColumnProps("asset_name", dataStateAssets)}
                  title="Name"
                  width={220}
                />
                <GridColumn
                  {...ColumnProps("asset_is_primary", dataStateAssets)}
                  title="Is Primary"
                  width={110}
                />
                <GridColumn
                  {...ColumnProps("asset_path", dataStateAssets)}
                  title="Path"
                />
              </Grid>
            </TabPane>
            <TabPane tabId="metadata">
              <Grid
                style={{ height: "500px" }}
                pageable={true}
                sortable={true}
                scrollable="scrollable"
                total={dataResultDistinctProductMetadata?.length}
                data={dataResultDistinctProductMetadata}
                {...dataStateDistinctProductMetadata}
                onDataStateChange={(e) => {
                  setDataStateDistinctProductMetadata(e.dataState);
                  setDataResultDistinctProductMetadata(process(distinctProductMetadata, e.dataState));
                }}
              >
                <GridColumn
                  {...ColumnProps("type_id", dataStateDistinctProductMetadata)}
                  title="Type ID"
                />
                <GridColumn
                  {...ColumnProps("product_id", dataStateDistinctProductMetadata)}
                  title="Product ID"
                />
                <GridColumn
                  {...ColumnProps("product_metadata", dataStateDistinctProductMetadata)}
                  title="Product Metadata"
                />
              </Grid>
            </TabPane>
          </TabContent>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={delegatesModalOpen}
        toggle={() => setDelegatesModalOpen(!delegatesModalOpen)}
        size="lg"
      >
        <ModalHeader toggle={() => setDelegatesModalOpen(false)}>
          <div className="d-flex align-items-center w-100">
            <div className="d-flex align-items-center">
              <FeatherIcon icon="users" size={18} className="me-2" />
              Delegates for {dataCatalogSingle.type_name}
            </div>
            <Button
              color="success"
              size="sm"
              className="ms-3"
              disabled={!canManageDelegates}
              onClick={handleOpenAddDelegates}
            >
              <FeatherIcon icon="plus" size={14} className="me-1" />
              Add Delegate
            </Button>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="grid_task_container_modal">
            <Grid
              style={{ height: "400px" }}
              sortable={true}
              total={dataResultDelegates?.length}
              data={dataResultDelegates}
              {...dataStateDelegates}
              onDataStateChange={(e) => {
                setDataStateDelegates(e.dataState);
                setDataResultDelegates(process(dataCatalogDelegates, e.dataState));
              }}
            >
              <GridColumn
                {...ColumnProps("user_name", dataStateDelegates)}
                title="Delegate Name"
              />
              <GridColumn
                {...ColumnProps("user_role", dataStateDelegates)}
                title="Role"
              />
              <GridColumn
                cell={renderDeleteDelegateCell}
              />
            </Grid>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={addDelegatesModalOpen}
        toggle={() => setAddDelegatesModalOpen(!addDelegatesModalOpen)}
        size="lg"
      >
        <ModalHeader toggle={() => {
          setAddDelegatesModalOpen(false);
          setDelegateSearchTerm(""); // Reset search when closing modal
        }}>
          <div className="d-flex align-items-center w-100">
            <div className="d-flex align-items-center me-3">
              <FeatherIcon icon="user-plus" size={18} className="me-2" />
              Add Delegates to {dataCatalogSingle.type_name}
            </div>
            <div className="d-flex align-items-center flex-grow-1">
              <FeatherIcon icon="search" size={16} className="me-2 text-muted" />
              <Input
                type="text"
                placeholder="Search by username..."
                value={delegateSearchTerm}
                onChange={(e) => setDelegateSearchTerm(e.target.value)}
                className="form-control-sm"
                style={{ maxWidth: "300px" }}
              />
              {delegateSearchTerm && (
                <Button
                  color="link"
                  size="sm"
                  className="p-1 ms-2"
                  onClick={() => setDelegateSearchTerm("")}
                  title="Clear search"
                >
                  <FeatherIcon icon="x" size={14} />
                </Button>
              )}
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="grid_task_container_modal">
            <Grid
              style={{ height: "400px" }}

              sortable={true}
              total={dataResultAvailableDelegates?.length}
              data={dataResultAvailableDelegates}
              {...dataStateAvailableDelegates}
              onDataStateChange={(e) => {
                setDataStateAvailableDelegates(e.dataState);
                // Re-apply search filter when grid state changes
                let filteredDelegates = dataCatalogAvailableDelegates;
                if (delegateSearchTerm.trim() !== "") {
                  filteredDelegates = dataCatalogAvailableDelegates.filter(delegate =>
                    delegate.name?.toLowerCase().includes(delegateSearchTerm.toLowerCase()) ||
                    delegate.first_name?.toLowerCase().includes(delegateSearchTerm.toLowerCase()) ||
                    delegate.last_name?.toLowerCase().includes(delegateSearchTerm.toLowerCase())
                  );
                }
                setDataResultAvailableDelegates(process(filteredDelegates, e.dataState));
              }}
            >
              <GridColumn
                {...ColumnProps("name", dataStateAvailableDelegates)}
                title="UserName"
              />
              <GridColumn
                {...ColumnProps("first_name", dataStateAvailableDelegates)}
                title="First Name"
              />
              <GridColumn
                {...ColumnProps("last_name", dataStateAvailableDelegates)}
                title="Last Name"
              />
              <GridColumn
                width={50}
                cell={renderAddDelegateCell}
              />
            </Grid>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};


export default DataCatalogDetail;
